import request from '@/apis/request'
const resource = 'affiliates' 

export default {
  getOverView: (params = {}) => {
    return request.get(`${resource}`, { params })
  }, 

  getCommissionSummary: (params = {}) => {
    return request.get(`${resource}/commissions/summary`, { params })
  }, 

  getMember: (params = {}) => {
    return request.get(`${resource}/members`, { params })
  }, 

  getCommissionHistory: (params = {}) => {
    return request.get(`${resource}/commissions/history`, { params })
  },  
}